//$(document).ready(function() {
  var pickupLabel = "Local Pickup - Mississauga"; // the text of the label
  var buttonArea = $('#shopify-section-cart-template .localbutton'); // where to insert the option
  var pickupVariantId = 49145009546; // the variant ID of the local pickup product
  var pickupLabel2 = "Local Pickup - Vancouver"; // the text of the label
  var buttonArea2 = $('#shopify-section-cart-template .localbutton'); // where to insert the option
  var pickupVariantId2 = 21208795938894; // the variant ID of the local pickup product
  var pickupLabel3 = "Appointment Pickup – Toronto *"; // the text of the label
  var buttonArea3 = $('#shopify-section-cart-template .localbutton'); // where to insert the option
  var pickupVariantId3 = 29247071649870; // the variant ID of the local pickup product  
  
//  Shopify.getCart(function(cart) {
//    var inCart = false;
//    $.each(cart.items, function(index, item) {
//      if (item.variant_id == pickupVariantId) {
//        inCart = true;
//        return false;
//      }
//    });
//    buttonArea.append('<div style="text-align: center; margin-top: 15px; margin-bottom:10px;"><label for="local-pickup" style="padding: 5px; border: 1px solid #000;"><input id="local-pickup" type="radio" name="group1"' + (inCart ? ' checked' : '') + ' /> ' + pickupLabel + '</label></div>');
//  });

//  buttonArea.on('change', '#local-pickup', function() {
//    if ($(this).is(':checked')) {
//      
//      Shopify.addItem(pickupVariantId, 1, function(item) {
//        location.reload();
//      });
//    } else {
//      Shopify.changeItem(pickupVariantId, 0, function(cart) {
//        location.reload();
//      });
//    }
//  });



//  Shopify.getCart(function(cart) {
//     var inCart = false;
//     $.each(cart.items, function(index, item) {
//       if (item.variant_id == pickupVariantId2) {
//         inCart = true;
//         return false;
//       }
//     });
//     buttonArea2.append('<div style="text-align: center; margin-top: 15px; margin-bottom:10px;"><label for="local-pickup2" style="padding: 5px; border: 1px solid #000;"><input id="local-pickup2" type="radio" name="group1"' + (inCart ? ' checked' : '') + ' /> ' + pickupLabel2 + '</label></div>');
//   });


//       buttonArea2.on('change', '#local-pickup2', function() {
 //    if ($(this).is(':checked')) {
//       Shopify.addItem(pickupVariantId2, 1, function(item) {
//         location.reload();
//       });
//     } else {
//       Shopify.changeItem(pickupVariantId2, 0, function(cart) {
//         location.reload();
//       });
//     }
//   });
    


 // Shopify.getCart(function(cart) {
  //  var inCart = false;
   // $.each(cart.items, function(index, item) {
   //   if (item.variant_id == pickupVariantId3) {
   //     inCart = true;
   //     return false;
   //   }
  //  });
 //   buttonArea3.append('<div style="text-align: center; margin-top: 15px; margin-bottom:10px;"><label for="local-pickup3" style="padding: 5px; border: 1px solid #000;"><input id="local-pickup3" type="radio" name="group1"' + (inCart ? ' checked' : '') + ' /> ' + pickupLabel3 + '</label></div>');
 // });

 //     buttonArea3.on('change', '#local-pickup3', function() {
 //   if ($(this).is(':checked')) {
 //     Shopify.addItem(pickupVariantId3, 1, function(item) {
        
   //     location.reload();
    //  });
   // } else {
   //   Shopify.changeItem(pickupVariantId3, 0, function(cart) {
        
  //      location.reload();
    //  });
  //  }
 // });
    
// });